export const AppButtonsSpacer: React.FC = () => {
  return <span style={{ flexGrow: 1 }} />;
};
